<script setup>
import { computed } from 'vue';

import AccessibleIcon from '@/assets/accessible.svg?component';
import AdjustmentsHorizontalIcon from '@/assets/adjustments-horizontal.svg?component';
import BadgeIcon from '@/assets/badge.svg?component';
import BoneIcon from '@/assets/bone.svg?component';
import BookIcon from '@/assets/book.svg?component';
import BrandCodesandboxIcon from '@/assets/brand-codesandbox.svg?component';
import BrandHipchatIcon from '@/assets/brand-hipchat.svg?component';
import BrandWechatIcon from '@/assets/brand-wechat.svg?component';
import BuildingStoreIcon from '@/assets/building-store.svg?component';
import CashBanknoteIcon from '@/assets/cash-banknote.svg?component';
import ChartBarIcon from '@/assets/chart-bar.svg?component';
import CheckboxIcon from '@/assets/checkbox.svg?component';
import CircleDashedIcon from '@/assets/circle-dashed.svg?component';
import CreditCardIcon from '@/assets/credit-card.svg?component';
import DownloadIcon from '@/assets/download.svg?component';
import FlagIcon from '@/assets/flag.svg?component';
import GiftIcon from '@/assets/gift.svg?component';
import HomeIcon from '@/assets/home.svg?component';
import ListDetailsIcon from '@/assets/list-details.svg?component';
import MapPinsIcon from '@/assets/map-pins.svg?component';
import MessageIcon from '@/assets/message.svg?component';
import Number123Icon from '@/assets/number-123.svg?component';
import ReceiptIcon from '@/assets/receipt.svg?component';
import ReceiptTaxIcon from '@/assets/receipt-tax.svg?component';
import RectangleIcon from '@/assets/rectangle.svg?component';
import RosetteDiscountIcon from '@/assets/rosette-discount.svg?component';
import SettingsIcon from '@/assets/settings.svg?component';
import ShoppingBagIcon from '@/assets/shopping-bag.svg?component';
import ShoppingCartIcon from '@/assets/shopping-cart.svg?component';
import StarIcon from '@/assets/Star.svg?component';
import TagsIcon from '@/assets/tags.svg?component';
import TruckDeliveryIcon from '@/assets/truck-delivery.svg?component';
import TruckIcon from '@/assets/truck.svg?component';
import UserCogIcon from '@/assets/user-cog.svg?component';
import UserIcon from '@/assets/user.svg?component';
import QuestionIcon from '@/assets/question.svg?component';
import PromoHistoryIcon from '@/assets/promocode-hiostory.svg?component';
import BonusHistoryIcon from '@/assets/bonus-history.svg?component';



const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  size: {
    type: [String, Number],
    default: 30,
  },
});

const iconMap = {
  'accessible': AccessibleIcon,
  'adjustments-horizontal': AdjustmentsHorizontalIcon,
  'badge': BadgeIcon,
  'bone': BoneIcon,
  'book': BookIcon,
  'brand-codesandbox': BrandCodesandboxIcon,
  'brand-hipchat': BrandHipchatIcon,
  'brand-wechat': BrandWechatIcon,
  'building-store': BuildingStoreIcon,
  'cash-banknote': CashBanknoteIcon,
  'chart-bar': ChartBarIcon,
  'activity': ChartBarIcon,
  'checkbox': CheckboxIcon,
  'circle-dashed': CircleDashedIcon,
  'circle': CircleDashedIcon,
  'disc': CircleDashedIcon,
  'credit-card': CreditCardIcon,
  'download': DownloadIcon,
  'flag': FlagIcon,
  'gift': GiftIcon,
  'home': HomeIcon,
  'list-details': ListDetailsIcon,
  'map-pins': MapPinsIcon,
  'message': MessageIcon,
  'message-square': MessageIcon,
  'number-123': Number123Icon,
  'receipt': ReceiptIcon,
  'receipt-tax': ReceiptTaxIcon,
  'rectangle': RectangleIcon,
  'rosette-discount': RosetteDiscountIcon,
  'percent': RosetteDiscountIcon,
  'settings': SettingsIcon,
  'shopping-bag': ShoppingBagIcon,
  'shopping-cart': ShoppingCartIcon,
  'star': StarIcon,
  'Star': StarIcon,
  'tags': TagsIcon,
  'truck-delivery': TruckDeliveryIcon,
  'truck': TruckIcon,
  'user-cog': UserCogIcon,
  'user': UserIcon,
  'x': AccessibleIcon,
  'questions':QuestionIcon,
  'bonus-history':BonusHistoryIcon,
  'promo-history':PromoHistoryIcon,
};

const iconComponent = computed(() => iconMap[props.name] || null);
</script>

<template>
  <component
      v-if="iconComponent"
      :is="iconComponent"
      :width="size"
      :height="size"
      class="feather"
  />
  <span v-else>
    </span>
</template>


<style scoped>
.feather {
  stroke: currentColor;
  stroke-width: 1;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
}

svg{
  height: 30px;
  width: 30px;
}
</style>